export default __webpack_public_path__ + "static/dropdownMenu_cloud_right-43d7cfd28179f489eec99f7cf9090bf1.png";